import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { reduxForm } from "redux-form";
import { Button, Loader } from "cxa-components";
import { StringField } from "cxa-form-field";
import { injectIntl } from "react-intl";
import messages from "components/messagesDescription";

const validateForm = (values, { intl }) => {
  const errors = {};
  if (!values.newPassword) {
    errors.newPassword = intl
      ? intl.formatMessage(messages.requiredDescription)
      : "Required";
  }
  if (!values.repeatNewPassword) {
    errors.repeatNewPassword = intl
      ? intl.formatMessage(messages.requiredDescription)
      : "Required";
  }
  if (values.newPassword !== values.repeatNewPassword) {
    errors.repeatNewPassword = intl
      ? intl.formatMessage(messages.passwordNotMatchDescription)
      : messages.passwordNotMatchDescription.defaultMessage;
  }
  return errors;
};

const PasswordResetForm = injectIntl(
  ({
    submitSucceeded,
    handleSubmit,
    onSubmit,
    submitting,
    error,
    intl,
    reset,
    policyDescription,
    history
  }) => {
    const submitted = useSelector(state => state.passwordReset.submitted)

    useEffect(() => {
      if (submitted && submitSucceeded) {
        const redirectTimer = setTimeout(() => {
          history.push("/");
        }, 1000); 
  
        return () => {
          clearTimeout(redirectTimer);
        };
      }
    }, [submitSucceeded]);

    return  (
      <form className="cxa-c-form" onSubmit={handleSubmit(values => onSubmit(values))} autoComplete="off">
        <fieldset>
          <StringField
            label={intl.formatMessage(messages.newPasswordDescription)}
            name="newPassword"
            type="password"
            required
            boxed
          />
          <StringField
            label={intl.formatMessage(messages.retypeNewPasswordDescription)}
            name="repeatNewPassword"
            type="password"
            required
            boxed
          />
        </fieldset>
        <p style={{ whiteSpace: "pre-line", fontSize: "12px" }}>
            {intl.formatMessage({id: "config.passwordPolicy", defaultMessage: policyDescription})}
        </p>        
        {error && reset() && null}
        {submitting && <Loader />}
        <p>
          <Button>{intl.formatMessage(messages.updateMyPasswordDescription)}</Button>
        </p>
      </form>
    );
  }
);

export default injectIntl(
  reduxForm({
    form: "passwordResetForm",
    validate: validateForm,
  })(PasswordResetForm)
);


// WEBPACK FOOTER //
// ./components/password/PasswordResetForm.js